import React from 'react';
import './InventarioFormDrawer.css';

function InventarioFormDrawer({ open, onClose, title, children }) {
    if (!open) return null;

    return (
        <>
            <div className="inventario-form-drawer-backdrop" onClick={onClose} aria-hidden="true" />
            <aside className="inventario-form-drawer" role="dialog" aria-label={title}>
                <div className="inventario-form-drawer__header">
                    <h2 className="inventario-form-drawer__title">{title}</h2>
                    <button type="button" className="inventario-form-drawer__close" onClick={onClose} aria-label="Fechar">
                        <i className="fas fa-times" />
                    </button>
                </div>
                <div className="inventario-form-drawer__body">
                    {children}
                </div>
            </aside>
        </>
    );
}

export default InventarioFormDrawer;
